export default __webpack_public_path__ + "static/media/slider2.fe3aacaa.jpg";